export default __webpack_public_path__ + "static/media/greenEmail.898cad2d.svg";